import { escapeHTML } from '../../utils/escape.js';

/**
 * Aclaración corta debajo del header de una categoría (ej. "Opción leche
 * vegetal +$700" en cafetería). Es informativa: mismo peso visual que una
 * descripción de producto, sin competir con el header.
 */
export const CategoryNote = (text) => `
    <p class="text-text-muted text-[10px] italic leading-tight mb-2 px-1">
        ${escapeHTML(text)}
    </p>
`;
